<template>
    <div>
      <div class="block">
        <el-carousel id="el-carousel" style="min-height: 227px;">
          <el-carousel-item v-for="item in bannerss" :key="item.id">
            <div width="100%" height="100%" :style="{ backgroundImage: `url(${item.image_url})` }" class="carousel-img" @click="tiaozhuanlist(item)"></div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
</template>

<script>
import {mapState } from 'vuex'
export default {
   data(){
    return{
      bannerss: [],
      bannerHeight: 700,
      screenWidth: 1920,
    }
   },
  created(){
    this.$store.dispatch('getOrgID', this.$store.state.domain).then(()=>{
      this.banners()
    })
  },
  computed: {
    ...mapState(['org_id'])
  },
  mounted() {
    this.setSize1()
    const that = this
    //监听浏览器窗口大小改变
    window.addEventListener(
      'resize',
      function () {
        var width =
          window.innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth
        that.screenWidth = width
        that.setSize()
      },
      false
    )
  },
   methods:{
     tiaozhuanlist(item) {
      
      if(item.is_new_window == 2){
        window.open(item.jump_path, '_self')
      }else {
        window.open(item.jump_path)
      }
    },
    // 获取轮播图
    banners() {
      const data = {
        org_id: this.org_id
      }
      this.$axios
        .post('/stu/course/banners', data)
        .then((res) => {
          if (res.data.code === 200) {
            this.bannerss = res.data.data
          }
        })
        .catch((err) => console.log(err))
    },
    once: function (fn) {
      let caller = true
      return function () {
        if (caller) {
          caller = false
          fn.apply(this, arguments)
        }
      }
    },

    setSize1: function () {
      var width =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth
      this.screenWidth = width
      //图片                高 / 宽  700 / 1920
      this.bannerHeight = (440 / 1920) * this.screenWidth
      if (document.getElementById('el-carousel')) {
        document.getElementById('el-carousel').style.height =
        this.bannerHeight + 'px'
      }
    },
    setSize: function () {
      this.bannerHeight = (440 / 1920) * this.screenWidth
      if (document.getElementById('el-carousel')) {
        document.getElementById('el-carousel').style.height =
        this.bannerHeight + 'px'
      }
    },
   }
}
</script>

<style scoped>
::v-deep .el-carousel__container {
  height: 100% !important;
}
.carousel-img {
  height: 100%;
  background-size: 100% auto;
  background-position: center;
  background-repeat: no-repeat;
}
</style>